export default "__VITE_ASSET__BmhJWSLW__"